var lx = lx || {};
lx.asset = lx.asset || {};

/* ex lxBookCal function*/
lx.asset.cal = function (pCpc, pStart, pOpen) {
    lx.load.add();
    var lAmtId, lObjId = vn("P223_OBJ_ID");

    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: 'APPLICATION_PROCESS=CPC_BOOK_CAL',
            x01: pCpc,
            x02: pStart,
            x03: lObjId
        },
        success: function (d) {
            lx.load.remove();
            $("#bottom_list").html(d);
            if (pOpen) {
                $("#bottom_list").animate({
                    height: "toggle"
                }, {
                        duration: 1250,
                        specialEasing: {
                            height: "easeOutQuad"
                        }
                    });
                var vTop = $("#bottom_list").offset().top;
                $("html,body").animate({
                    scrollTop: (vTop - 140)
                }, 1250);
            }
        }
    })
};

/* ex lxBookInsert function*/
lx.asset.insert = function (pCpc, pUpdate) {
    lx.load.add();
    var lAmtId, lObjId = vn("P223_OBJ_ID");
    if (pUpdate) lAmtId = $v("P223_AMT_ID");
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: 'APPLICATION_PROCESS=CPC_BOOK_INSERT',
            x01: pCpc,
            x02: $v('lx-book-user'),
            x03: $v('lx-book-start-date'),
            x04: $v('lx-book-end-date'),
            x05: lObjId,
            x06: lAmtId
        },
        success: function (d) {
            lx.load.remove();
            if (d == 1) {
                alert(apex.lang.getMessage("JS4"));
            } else if (d == 2) {
                alert(apex.lang.getMessage("JS5"));
            } else {
                alert(apex.lang.getMessage("JS6"));
            }
        }
    })
};

/* ex lxBookCheck function*/
lx.asset.check = function (pCpc, pUpdate) {
    lx.load.add();
    var lAmtId, lObjId = vn("P223_OBJ_ID");
    if (pUpdate) lAmtId = $v("P223_AMT_ID");
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: 'APPLICATION_PROCESS=CPC_BOOK_CHECK',
            x01: pCpc,
            x02: $v('lx-book-user'), //lx-book-user
            x03: $v('lx-book-start-date'),
            x04: $v('lx-book-end-date'),
            x05: lObjId,
            x06: lAmtId
        },
        success: function (d) {
            var retValues = d.split(":");
            lx.load.remove();
            if (retValues[0] == 1) {
                $s("lx-book-qty", retValues[1]);
                $s("lx-book-total", retValues[2]);
                /*$("#lx-book-qty").show();
                $("#lx-book-total").show();
                $(".lx-book-hide").show();*/
                /*alert(apex.lang.getMessage("JS7"));*/
				alert('Free');
            } else if (retValues[0] == 2) {
                /*alert(apex.lang.getMessage("JS8"));*/
				alert('Not Free');
            } else {
                alert(apex.lang.getMessage("JS6"));
            }
        }
    })
};

lxBookCal = lx.asset.cal;
lxBookInsert = lx.asset.insert;
lxBookCheck = lx.asset.check;